<script>
	import { createEventDispatcher } from 'svelte';
	import { DialogNew, notifications } from '@shopboxai/sb-portal-components';
	import { createToken } from '../../utils/api.js';
	import { websiteClientId } from '../../utils/utils.js';

	let data = {
		apiScope: true
	};
	export let visible = false;
	const dispatch = createEventDispatcher();
	const sumbitCreate = async () => {
		try {
			notifications.info('Generating token...', 2000);
			await createToken(data.name, $websiteClientId, data.apiScope, data.reportingScope);
			data = {
				apiScope: true
			};
			notifications.success('Token generated', 2000);
		} catch (error) {
			notifications.danger('Soemthing went wrong', 2000);
		} finally {
			dispatch('complete');
		}
	};

	const tomorrow = () => {
		const today = new Date();
		today.setDate(today.getDate() + 1);
		return today.toISOString().slice(0, 10);
	};
</script>

<DialogNew on:submit={sumbitCreate} on:close bind:visible>
	<button slot="toggle" style="display: none;"> + Generate new API tokens </button>
	<div slot="header">Generate API token</div>
	<button class="primary" slot="primary-action"> Generate </button>
	<div slot="content">
		<label for="name">Token name </label>
		<input id="name" type="text" bind:value={data.name} required />
		<label for="apiscope" style="display:flex; align-items:center;gap:10px;margin-bottom:12px;">
			<input
				style="flex-grow:0;width:auto;margin:0;"
				type="checkbox"
				id="apiscope"
				name="apiscope"
				bind:checked={data.apiScope}
			/>
			Api Access
		</label>
		<label for="reportscope" style="display:flex; align-items:center;gap:10px;margin-bottom:12px;">
			<input
				style="flex-grow:0;width:auto;margin:0;"
				type="checkbox"
				id="reportscope"
				name="reportscope"
				bind:checked={data.reportingScope}
			/>
			Reporting Access
		</label>
	</div>
</DialogNew>
